var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormTemplatesEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M80 160c44.183 0 80-35.817 80-80S124.183 0 80 0 0 35.817 0 80s35.817 80 80 80Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.581 30H43.608C41.063 30 39 32.05 39 34.58v90.84c0 2.529 2.063 4.58 4.608 4.58h71.973c2.544 0 4.607-2.051 4.607-4.58V34.58c0-2.53-2.063-4.58-4.607-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEAFE",
    d: "M107 56H52a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h55a2 2 0 0 0 2-2V58a2 2 0 0 0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M103.5 63h-50a1.5 1.5 0 0 1 0-3h50a1.5 1.5 0 0 1 0 3ZM99.5 68h-46a1.5 1.5 0 0 1 0-3h46a1.5 1.5 0 0 1 0 3ZM55.833 40h-4.666A1.167 1.167 0 0 0 50 41.167v4.666A1.168 1.168 0 0 0 51.167 47h4.666A1.168 1.168 0 0 0 57 45.833v-4.666A1.167 1.167 0 0 0 55.833 40Zm.018 2.35-2.917 2.917a.437.437 0 0 1-.618 0l-1.167-1.166a.437.437 0 0 1 .618-.618l.858.856 2.608-2.606a.44.44 0 0 1 .768.303.437.437 0 0 1-.15.315v-.001ZM90.833 99h-4.666A1.167 1.167 0 0 0 85 100.167v4.666a1.17 1.17 0 0 0 .72 1.078c.142.059.294.089.447.089h4.666a1.161 1.161 0 0 0 .826-.342 1.165 1.165 0 0 0 .341-.825v-4.666A1.167 1.167 0 0 0 90.833 99Zm.018 2.351-2.917 2.916a.43.43 0 0 1-.309.129.437.437 0 0 1-.309-.129l-1.167-1.166a.437.437 0 0 1 .314-.73.432.432 0 0 1 .304.111l.858.857 2.608-2.607a.455.455 0 0 1 .312-.139.44.44 0 0 1 .413.274.438.438 0 0 1-.107.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M71.75 40h-4.5c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25ZM106.75 99h-4.5c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25ZM87.75 40h-4.5c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25ZM67.5 89h-14a3.5 3.5 0 1 0 0 7h14a3.5 3.5 0 1 0 0-7ZM107.5 110h-54a3.5 3.5 0 1 0 0 7h54a3.5 3.5 0 1 0 0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEAFE",
    d: "M67.5 99h-14a3.5 3.5 0 1 0 0 7h14a3.5 3.5 0 1 0 0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M67.5 104h-14a1.5 1.5 0 0 1 0-3h14a1.5 1.5 0 0 1 0 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 97.188,
    height: 116,
    x: 31,
    y: 28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1873_11965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1873_11965",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormTemplatesEmptyState);
export default __webpack_public_path__ + "static/media/formTemplatesEmptyState.75d03737c0d4d5e7f0af90d227a41e65.svg";
export { ForwardRef as ReactComponent };